import { DataPage } from "@xbs/muon";
import { getFormat } from "../helpers/format";
import { getCellIds, getCellInfo } from "./../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";

export class SetCellFormat implements IAction {
	public config: IActionConfig;
	private _page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page;
	}

	do() {
		const { cell, grid } = this.config;
		let val = this.config.val;
		const { row, col } = getCellIds(cell, grid);
		const format = getFormat(val);
		val = (format && format.mask) || val;

		const cellInfo = getCellInfo(cell, this._page, grid);
		if (cellInfo.locked) {
			return;
		}

		if (!this.config.spreadsheet.events.fire(SpreadsheetEvents.beforeFormatChange, [cell, val])) {
			return;
		}
		const cellFormat = cellInfo.format
		this.config.prev = cellInfo.format?.id;
		const math = this.config.spreadsheet.getFormula(cell);

		if ((cellFormat?.mask !== "@" && val === "@") ) {
			this._page.setValue(row,col, `${math ? "=" + math : cellInfo.value || ""}`, 1);
		} 
		if (cellFormat?.mask === "@" && val !== "@") {
			this._page.setValue(row,col, math ? "=" + math : cellInfo.value, 0);
		}


		this._page.setCell(row, col, {
			format: format || getFormat("common"),
		});

		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterFormatChange, [cell, val]);
		this.config.grid.paint();
	}

	undo() {
		const val = this.config.val;
		const prev = this.config.prev;

		this.config.val = prev;
		this.config.prev = val;
		this.do();

		this.config.val = val;
		this.config.prev = prev;
	}
}
